import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {OneMonthFreeMode, OneMonthFreeStep} from "../../../one-month-free.component";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../../../user/user-subscription";
import {PaymentInfoComponent} from "../../../../../payment-info/payment-info.component";
import {FormControl} from "@angular/forms";
import {DbValidators} from "../../../../../../validators/DbValidators";
import {CouponCode} from "../../../../../../../workspace/billing/coupon";
import {AuthService} from "../../../../../../../auth/auth.service";
import {filter, first, switchMap} from "rxjs/operators";
import {CouponCodeMapper} from "../../../../../../../workspace/billing/coupon-mapper";
import {Config} from "../../../../../../../config/config";
import {User} from "../../../../../../../user/user";
import {ChosenPlan} from "../../../../../payment-info/models/plan.model";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {DbNumberFormatPipe} from "../../../../../../../shared/pipes/db-number-ceil.pipe";
import * as fromStore from "../../../../../../../store";
import {Utils} from "../../../../../../utils/utils";
import {Store} from "@ngrx/store";
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";
import reviewers from "../../one-week-free-demo-upgrade/reviewers.json";

@Component({
    selector: 'db-pricing-page-checkout',
    templateUrl: './pricing-page-checkout.component.html',
    styleUrls: ['./pricing-page-checkout.component.scss'],
    standalone: false
})
export class PricingPageCheckoutComponent implements OnInit, OnChanges {

  @ViewChild(PaymentInfoComponent) paymentInfo: PaymentInfoComponent;
  @Input() mode: OneMonthFreeMode;
  @Input() demoUser: boolean;
  @Input() couponPercent: number;
  @Input() couponDays: number;
  @Input() hasCampaignCoupon = false;
  @Input() hasBackBtn?: boolean = false;
  @Input() isAgency: boolean = false;
  @Input() isInvited: boolean = false;
  @Input() userSubscription: UserSubscription;
  @Input() user: User;
  @Input() chosenPlan: ChosenPlan;
  @Input() couponCode: string;
  @Input() isPaid?: boolean = false;
  @Input() paidDesc?: string;
  @Input() expirationDate?: string;
  @Input() dataCenter?: string;
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();
  @Output() onClose = new EventEmitter<boolean>();
  @Output() onBack = new EventEmitter();
  @Output() changeSubscription = new EventEmitter<UserSubscription>();

  public loading = false;
  public couponLoading = false;
  public couponSectionToggled = false;
  public couponCodeInput = new FormControl('', [DbValidators.trim]);
  public coupon: CouponCode;
  public newPrice: number;
  public Config = Config;
  public periodSwitch: FormControl;
  public monthlySubscription: ChosenPlan;
  public annuallySubscription: ChosenPlan;
  public payPalInvalidCoupons = Config.couponsList.slice(1);
  public isPaypal = false;
  public annuallyPaymentDate = new Date();
  public monthlyPaymentDate = new Date();
  public isMobile = window.innerWidth <= 991;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  public DbNumberFormatPipe = DbNumberFormatPipe;
  public reviewers = reviewers;

  private readonly _destroyPendingRequests$ = new Subject<void>();
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _authService: AuthService,
    private _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    this._activeModal.resize(600, 1000);
    this.periodSwitch = new FormControl(this.chosenPlan.periodNumber);
    if (!this.couponCode) {
      if (localStorage.getItem('dbCouponFromEmail')) {
        this.couponCode = localStorage.getItem('dbCouponFromEmail');
      } /*else if (!this.isPaid) {
        const couponCode = '1wf';
        this.applyCoupon(false, couponCode);
      }*/
    }
    if (!!this.couponCode && this.hasCampaignCoupon && !this.isPaid) {
      if (this.couponCode !== '1wf' &&
        (!localStorage.getItem('dbCouponFromEmail') ||
          (localStorage.getItem('dbCouponFromEmail') && this.couponCode !== localStorage.getItem('dbCouponFromEmail')))) {
        this.couponSectionToggled = true;
        this.couponCodeInput.setValue(this.couponCode);
      }
      this.applyCoupon(false, this.couponCode);
    }
    this._getAnnuallyPaymentDate();
    if (this.chosenPlan?.category === UserSubscriptionCategory.DedicatedVM) {
      this.chosenPlan.title = 'Agency Ultimate';
      this.monthlySubscription = this.chosenPlan?.monthlyPlan;
      this.annuallySubscription = this.chosenPlan?.annuallyPlan;
    }
    else this._getUpgradeableSubscription(parseInt(this.chosenPlan?.coupleId, 10));
  }

  public closeDialog(event) {
    this._activeModal.close();
    this.onClose.emit(event === 'upgraded');
  }

  public changePlan(period: number): void {
    this.chosenPlan = period === 1 ? this.monthlySubscription : this.annuallySubscription;
    this.changeSubscription.emit();
    this.periodSwitch.setValue(period);
    if (!!this.couponCode) {
      this.applyCoupon(false, this.couponCode);
    }
  }

  private _getUpgradeableSubscription(subscriptionId): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserAvailableSubscription(subscriptionId, true, 'platform'))),
        takeUntil(this._destroyStream$)
      )
      .subscribe((userSubscription: UserSubscription) => {
        if (userSubscription) {
          const coupleSubscription = Utils.findPlanForDataCenter(userSubscription, this.dataCenter, parseInt(this.chosenPlan?.coupleId, 10));
          const coupleChosenPlan: ChosenPlan = {
            id: coupleSubscription?.id,
            title: coupleSubscription?.plan?.title,
            price: coupleSubscription?.plan?.planPrice,
            type: this.periodSwitch?.value === 12 ? 'year' : 'month',
            coupon: coupleSubscription?.couponCode,
            periodNumber: coupleSubscription.periodNumber,
          };

          if (this.chosenPlan.periodNumber === 1) {
            this.monthlySubscription = this.chosenPlan;
            this.annuallySubscription = coupleChosenPlan;
          }
          else {
            this.monthlySubscription = coupleChosenPlan;
            this.annuallySubscription = this.chosenPlan;
          }
        }
        this.demoUser = Utils.isDemoUser(userSubscription, this.user);
      });
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['chosenPlan'] && changes['chosenPlan'].currentValue) {
      this._destroyPendingRequests$.next();

      this.chosenPlan = changes['chosenPlan'].currentValue;
      this.newPrice = 0;

      if (!!this.couponCode) {
        this.applyCoupon(false, this.couponCode);
      }
      this._getAnnuallyPaymentDate();
    }
  }

  public deleteCoupon(reset = true) {
    this._sendEvent("Dashboard Action", "Remove Coupon", this.coupon?.couponCode);
    this.couponCodeInput.reset();
    this.coupon = null;
    if (reset) {
      const coupon = localStorage.getItem('dbCouponFromEmail') || '1wf';
      this.applyCoupon(reset, coupon);
    }
  }

  public applyCoupon(reset = false, autoApply?): void {
    const coupon = autoApply ? autoApply : this.couponCodeInput.value;

    if (coupon === '1wf') {
      this.unavailableCoupon();
      return;
    }
    this.couponLoading = true;

    this._destroyPendingRequests$.next();

    this._authService.applyCoupon(this.chosenPlan.id, coupon, "")
      .pipe(
        first(response => !!response, null),
        takeUntil(this._destroyPendingRequests$)
      )
      .subscribe({
        next: (response) => {
          reset && (this.newPrice = 0);
          this.couponLoading = false;

          if (!!response?.data?.free_days_before_payment) {
            this.unavailableCoupon();
            return;
          }

          if (this.chosenPlan?.category !== UserSubscriptionCategory.DedicatedVM ||
              (this.chosenPlan?.category === UserSubscriptionCategory.DedicatedVM && !response?.data?.free_days_before_payment)) {
              this.couponCode = coupon;
              this.couponCodeInput.setErrors(null);
              this.coupon = CouponCodeMapper.map(response.data);
              this.newPrice = response.data && response.data.new_price;
              this.couponPercent = response.data.first_amount;
                const date = new Date();
                date.setDate(date.getDate() + response?.data?.free_days_before_payment);
                this.expirationDate = date.toDateString();
          }
        },
        error: () => {
          this.unavailableCoupon();
        }
      });
  }

  unavailableCoupon(): void {
    this.couponLoading = false;
    this.newPrice = 0;
    this.deleteCoupon(false);
    this.couponCodeInput.setErrors({'invalidCode': true});
  }

  public changeSubscrId(): void {
    localStorage.setItem('dbCheckoutSubscriptionId', this.chosenPlan.id.toString());
  }

  public handlePaymentIsPaypal(isPaypal: boolean) {
    this.isPaypal = isPaypal;
  }

  private _getAnnuallyPaymentDate(): void {
    const today = new Date();
    this.annuallyPaymentDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() + 7);
    this.monthlyPaymentDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 7);
  }

  private _sendEvent(category, action, label): void {
    const analyticsData = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  ngOnDestroy() {
    this._destroyPendingRequests$.next();
    this._destroyPendingRequests$.complete();
  }

}
